import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setIsToggle } from "../../../redux/reducers/assetReducer";

const Sidebar = ({ type }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch()
  const {isToggle} = useSelector(state=>state.assetReducer)
  const sidemenu = [
    {
      label: "Notification preference",
      value: "notification",
      url: "/assets/img/icon/Notification.png",
    },
    {
      label: "My Account",
      value: "my-account",
      url: "/assets/img/icon/user-circle.png",
    },
    {
      label: "Change Password",
      value: "change-password",
      url: "/assets/img/icon/lock.png",
    },
    {
      label: "My Subscription",
      value: "subscription",
      url: "/assets/img/icon/payment.png",
    },
    {
      label: "Delete Account",
      value: "delete-account",
      url: "/assets/img/icon/delete.png",
    },
  ];

  const handleTabChange = (tabType) => {
    navigate(`/account-setting/${tabType}`);
  };

  return (
    <aside
      class={`{profile-sidebar ct_right_main_box d-lg-block  ct_mb_50 ${isToggle == true ? "ct_show" : ""}`}
      id="profileSidebar"
    >
      <div class="d-flex align-items-center justify-content-between gap-3 py-3 px-2">
        <h5 class="ct_fs_20 ct_fw_600 mb-0">Account Setting</h5>
        <button
          class={`btn border-0 bg-transparent p-0 d-lg-none d-block`}
          onClick={()=>{
            dispatch(setIsToggle(false))
          }}
          id="profileSidebarClose"
        >
          <i class="fa fa-times"></i>
        </button>
      </div>

      <ul class="profile-sidebar-menu px-0 mt-3">
        {sidemenu.map((item) => {
            const isChangePassword = item?.value === "change-password";

         return  <li class="">
            <a
              className={type == item?.value ? "active" : ""}
                onClick={() => {
          if (!isChangePassword) {
            handleTabChange(item?.value);
          }
        }}
        {...(isChangePassword && {
          "data-bs-toggle": "modal",
          "data-bs-target": "#mobileAppModal",
        })}
            >
              <img src={item?.url} alt="" class="me-2" />
              {item?.label}
            </a>
          </li>
        })}
      </ul>
    </aside>
  );
};

export default Sidebar;
